module.exports = __webpack_public_path__ + "static/media/home2.5cf05bba.jpg";